export const WINDOW_TITLE = {
  RESET_PASSWORD: 'Reset password - Avanga 2.0',
  JOIN_YOUR_TEAM: 'Join your team - Avanga 2.0',
  FORGOT_PASSWORD: 'Forgot password - Avanga 2.0',
  SIGN_IN: 'Sign in - Avanga 2.0',
};
